const API = `https://api.cinquex.com/api`

export default API